"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  palette: {
    primary: {
      main: 'rgb(117, 40, 100)',
      light: 'rgb(117, 40, 100)',
      dark: 'rgb(93, 12, 51)',
      contrastText: '#FFFFFF'
    }
  }
};
exports["default"] = _default;